import { Component, OnInit, OnDestroy } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { Message, SpinnerService, UtilsService } from 'shared-components';
import { EtiquetadoContextService } from "../../context/etiquetado-context.service";
import { EtiquetadoService } from "../../services/etiquetado.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";

@Component({
    selector: 'app-consumos',
    templateUrl: './consumos.component.html'
})
export class ConsumosComponent implements OnInit, OnDestroy {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;
    private _filters;
    public filtersVisible = true;
    public filtersForm: UntypedFormGroup;

    public toCloseSpinner = 0;

    public consumos;
    public almacenes;
    public confecciones;
    public municipios;
    public provincias;
    public denominaciones;
    public campanyas;
    public etiquetadores;
    public marcas;

    public paisId;
    public denominacionId;
    public consumoId;

    public reimpresionesModal = false;
    public incidenciasModal = false;

    public disabledAlmacenes: Subject<boolean> = new Subject();
    public disabledMunicipios: Subject<boolean> = new Subject();
    public disabledConfecciones: Subject<boolean> = new Subject();
    public disabledProvincias: Subject<boolean> = new Subject();
    public disabledDenominaciones: Subject<boolean> = new Subject();
    public disabledCampanya: Subject<boolean> = new Subject();
    public disabledEtiquetadores: Subject<boolean> = new Subject();
    public disabledMarcas: Subject<boolean> = new Subject();

    public orderBy: string;
    public columnId: number;

    public mensajes = new Array<Message>();
    public showError: boolean;
    public showWarning: boolean;

    public dropdownInfo: number;
    public dropdownSection: number;
    public pestanaActiva = new Array<number>();

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    private readonly destroy$ = new Subject<void>();

    constructor(
        private readonly _router: Router,
        private _fb: UntypedFormBuilder,
        private readonly _translate: TranslateService,
        private readonly _sessionContext: SessionContextService,
        private readonly _spinnerService: SpinnerService,
        private readonly _etiquetadoService: EtiquetadoService,
        private readonly _etiquetadoContext: EtiquetadoContextService,
        private readonly _dataProvider: DataProvider,
        private readonly _utilsService: UtilsService
    ) { }

    ngOnInit() {
        this.filtersForm = this._fb.group({
            campanya: [{ value: '', disabled: true }, Validators.required],
            etiquetador: [{ value: '', disabled: true }, Validators.required],
            almacen: [{ value: '', disabled: true }],
            pais: ['', Validators.required],
            provincia: [{ value: '', disabled: true }],
            municipio: [{ value: '', disabled: true }],
            denominacion: [{ value: '', disabled: true }, Validators.required],
            marca: [{ value: '', disabled: true }],
            paisDestino: [''],
            desFinca: [''],
            desProductor: [''],
            lote: [''],
            licencia: [''],
            confeccion: [{ value: '', disabled: true }],
            tipoConfeccion: [''],
            codigoSNC: ['', Validators.required],
            fechaInicio: [''],
            fechaFin: [''],
            consumo: ['']
        });

        this._etiquetadoContext.consumosFilters = null;


        this.checkWarnings(this.filtersForm.get('pais').value);

        this.filtersForm.get('fechaInicio').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());
        this.filtersForm.get('fechaFin').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());

        this.filtersForm.get('pais').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((pais) => {
            if (pais) {
                this.paisId = pais.id;
                this.getProvinciasByPais(pais.id);
                this.getDenominacionesByPais(pais.id);
                this.filtersForm.get('codigoSNC').clearValidators();
                this.filtersForm.get('codigoSNC').updateValueAndValidity();
            } else {
                this.disabledProvincias.next(true);
                this.disabledDenominaciones.next(true);
                this.provincias = [];
                this.denominaciones = [];
                this.filtersForm.get('provincia').patchValue('');
                this.filtersForm.get('provincia').disable();
                this.filtersForm.get('denominacion').patchValue('');
                this.filtersForm.get('denominacion').disable();
                this.filtersForm.get('codigoSNC').setValidators(Validators.required);
                this.filtersForm.get('codigoSNC').updateValueAndValidity({ onlySelf: true, emitEvent: false });
            }
        });

        this.filtersForm.get('denominacion').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((denominacion) => {
            if (denominacion) {
                this.denominacionId = denominacion.id;
                this.getCampanyasByDenominacion(denominacion.id, this.paisId);
            } else {
                this.disabledCampanya.next(true);
                this.campanyas = [];
                this.filtersForm.get('campanya').patchValue('');
                this.filtersForm.get('campanya').disable();
            }
        });

        this.filtersForm.get('campanya').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((campanya) => {
            if (campanya) {
                this.getEtiquetadoresByCampanya(campanya.id);
            } else {
                this.disabledEtiquetadores.next(true);
                this.etiquetadores = [];
                this.filtersForm.get('etiquetador').patchValue('');
                this.filtersForm.get('etiquetador').disable();
            }
        });

        this.filtersForm.get('etiquetador').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((etiquetador) => {
            if (etiquetador) {
                this.getConfeccionesByEtiquetador(etiquetador.id);
                this.getAlmacenesByEtiquetador(etiquetador.id);
                this.getMarcasByEtiquetador(etiquetador.id);
            } else {
                this.disabledConfecciones.next(true);
                this.disabledAlmacenes.next(true);
                this.disabledMarcas.next(true);
                this.confecciones = [];
                this.almacenes = [];
                this.marcas = [];
                this.filtersForm.get('confeccion').patchValue('');
                this.filtersForm.get('confeccion').disable();
                this.filtersForm.get('almacen').patchValue('');
                this.filtersForm.get('almacen').disable();
                this.filtersForm.get('marca').disable();
                this.filtersForm.get('marca').patchValue('');
            }
        });

        this.filtersForm.get('provincia').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((provincia) => {
            if (provincia) {
                this.getMunicipiosByProvincia(provincia.id);
            } else {
                this.disabledMunicipios.next(true);
                this.municipios = [];
                this.filtersForm.get('municipio').patchValue('');
                this.filtersForm.get('municipio').disable();
            }
        });

        this.filtersForm.get('codigoSNC').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((des) => {
            if (des) {
                this.filtersForm.get('pais').clearValidators();
                this.filtersForm.get('pais').updateValueAndValidity({ onlySelf: true, emitEvent: false });
            } else {
                this.filtersForm.get('pais').setValidators(Validators.required);
                this.filtersForm.get('pais').updateValueAndValidity({ onlySelf: true, emitEvent: false });
            }
        });

        if (this._dataProvider.paises) {
          if (this._dataProvider.paises.length === 1 && this.filtersForm.get('pais').enabled) {
              this.filtersForm.get('pais').patchValue(this._dataProvider.paises[0]);
              this.filtersForm.get('pais').disable();
          }
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get paises() {
        return this._dataProvider.paises;
    }

    public get destinos() {
        return this._dataProvider.destinos;
    }

    public get tiposConsumo() {
        return this._dataProvider.tiposConsumo;
    }

    public get tiposConfeccion() {
        return this._dataProvider.tiposConfeccion;
    }

    public get isSmallScreen() {
        return this._sessionContext.isSmallScreen();
    }

    public getProvinciasByPais(paisId) {
        let filters = {
            paisId: paisId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.getProvinciasByPaisId(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.provincias = resp.lista;
                this.filtersForm.get('provincia').enable();
                this.disabledProvincias.next(false);
            }
        });
    }

    public getMunicipiosByProvincia(provinciaId) {
        let filters = {
            provinciaId: provinciaId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.getMunicipiosByProvinciaId(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.municipios = resp.lista;
                this.filtersForm.get('municipio').enable();
                this.disabledMunicipios.next(false);
            }
        });
    }

    public getDenominacionesByPais(paisId) {
        let filters = {
            paisId: paisId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.getDenominaciones(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.denominaciones = resp.lista;
                if (this.denominaciones.length === 1) {
                    this.filtersForm.get('denominacion').patchValue(this.denominaciones[0]);
                    this.filtersForm.get('denominacion').disable();
                    this.disabledDenominaciones.next(true);
                } else {
                    this.filtersForm.get('denominacion').enable();
                    this.disabledDenominaciones.next(false);
                }
            }
        });
    }

    public getCampanyasByDenominacion(denominacionId, paisId) {
        let filters = {
            denominacionId: denominacionId,
            paisId: paisId,
            volcadoHistorico: false
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.getCampanyas(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.campanyas = resp.lista;
                this.campanyas.forEach(campanya => {
                    campanya.des = campanya.anyo.toString();
                });
                this.filtersForm.get('campanya').patchValue(this.campanyas[0]);
                this.filtersForm.get('campanya').enable();
                this.disabledCampanya.next(false);
            }
        });
    }

    public getConfeccionesByEtiquetador(etiquetadorId) {
        let filters = {
            etiquetadorId,
            denominacionId: this.denominacionId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.getConfecciones(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.confecciones = resp.lista;
                this.filtersForm.get('confeccion').enable();
                this.disabledConfecciones.next(false);
            }
        });
    }

    public getAlmacenesByEtiquetador(etiquetadorId) {
        let filters = {
            etiquetadorId: etiquetadorId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.getAlmacenesByEtiquetadorId(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.almacenes = resp.lista;
                this.filtersForm.get('almacen').enable();
                this.disabledAlmacenes.next(false);
            }
        });
    }

    public getEtiquetadoresByCampanya(campanyaId) {
        let filters = {
            campanyaId: campanyaId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.getEtiquetadores(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.etiquetadores = resp.lista;

                if (this.etiquetadores.length === 1) {
                    this.filtersForm.get('etiquetador').patchValue(this.etiquetadores[0]);
                } else {
                    this.filtersForm.get('etiquetador').enable();
                    this.disabledEtiquetadores.next(false);
                }
            }
        });
    }

    public getMarcasByEtiquetador(etiquetadorId) {
        let filters = {
            paisId: this.paisId,
            etiquetadorId: etiquetadorId,
            denominacionId: this.denominacionId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.getMarcas(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.marcas = resp.lista;
                this.marcas.unshift({ id: -1, des: this._translate.instant('global.sinMarca') });
                this.filtersForm.get('marca').enable();
                this.disabledMarcas.next(false);
            }
        });
    }

    private showGeneralOrCountrySncMessage(className = 'error') {
        if (!this.filtersForm.get('pais').value && !this.filtersForm.get('codigoSNC').value) {
            this.mensajes.push({ class: className, message: 'consumos.info.paisSnc' });
        } else {
            this.mensajes.push({ class: className, message: 'global.info.filterRequired' });
        }
    }

    private checkWarnings(campanya) {
        if (campanya && this.filtersForm.valid) {
            this.filtersVisible = false;
            this.showWarning = false;
            this.mensajes = [];
            this.getConsumos();
        } else {
            this.filtersVisible = true;
            this.showWarning = true;

            this.showGeneralOrCountrySncMessage('warning');
        }
    }

    public pageChange(page) {
        this.dropdownInfo = -1;
        this.dropdownSection = -1;
        this._etiquetadoContext.consumosFilters.numPagina = this.currentPage = page - 1;
        this.getConsumos();
    }

    public itemsPerPageChange(items) {
        this.dropdownInfo = -1;
        this.dropdownSection = -1;
        this._etiquetadoContext.consumosFilters.numPagina = this.currentPage = 0;
        this._etiquetadoContext.consumosFilters.tamPagina = this.itemsPerPage = items;
        this.getConsumos();
    }

    public validDates() {
        if (this.filtersForm.get('fechaInicio').value && this.filtersForm.get('fechaFin').value) {
            if (this.checkDates(this.filtersForm.get('fechaInicio').value, this.filtersForm.get('fechaFin').value)) {
                this.clearDatesValidators();
            } else {
                this.filtersForm.get('fechaInicio').setErrors(['Invalid date']);
                this.filtersForm.get('fechaFin').setErrors(['Invalid date']);
            }
            if (this.filtersForm.get('fechaInicio').invalid || this.filtersForm.get('fechaFin').invalid) {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.fecha.error.finAnteriorInicio' });
            } else {
                this.showError = false;
                this.mensajes = [];
            }
        } else {
            this.clearDatesValidators();
            this.showError = false;
            this.mensajes = [];
        }
    }

    private clearDatesValidators() {
        if (this.filtersForm.get('fechaFin').errors && this.filtersForm.get('fechaFin').errors.includes('Invalid date')) {
            this.filtersForm.get('fechaFin').clearValidators();
            this.filtersForm.get('fechaFin').updateValueAndValidity();
        }
        if (this.filtersForm.get('fechaInicio').errors && this.filtersForm.get('fechaInicio').errors.includes('Invalid date')) {
            this.filtersForm.get('fechaInicio').clearValidators();
            this.filtersForm.get('fechaInicio').updateValueAndValidity();
        }
    }

    private checkDates(inicio, fin) {
        const inicioD = new Date(inicio);
        const finD = new Date(fin);
        return inicioD <= finD;
    }

    public checkValuesForm(): boolean {
        return (this.filtersForm.get('campanya').value ||
            this.filtersForm.get('etiquetador').value ||
            this.filtersForm.get('almacen').value ||
            this.filtersForm.get('municipio').value ||
            this.filtersForm.get('paisDestino').value ||
            this.filtersForm.get('desFinca').value ||
            (this.filtersForm.get('pais').value && this.filtersForm.get('pais').enabled) ||
            this.filtersForm.get('provincia').value ||
            (this.filtersForm.get('denominacion').value && this.filtersForm.get('denominacion').enabled) ||
            this.filtersForm.get('licencia').value ||
            this.filtersForm.get('desProductor').value ||
            this.filtersForm.get('lote').value ||
            this.filtersForm.get('consumo').value ||
            this.filtersForm.get('marca').value ||
            this.filtersForm.get('confeccion').value ||
            this.filtersForm.get('tipoConfeccion').value ||
            this.filtersForm.get('codigoSNC').value ||
            this.filtersForm.get('fechaInicio').value ||
            this.filtersForm.get('fechaFin').value) ? true : false;
    }

    public resetForm() {
      if (this.filtersForm.get('pais').disabled){
        this.filtersForm.reset({
          pais: this.filtersForm.get('pais').value
        });
      } else {
        this.filtersForm.controls['pais'].reset();
        this.filtersForm.controls['desProductor'].reset();
        this.filtersForm.controls['lote'].reset();
        this.filtersForm.controls['licencia'].reset();
        this.filtersForm.controls['paisDestino'].reset();
        this.filtersForm.controls['fechaInicio'].reset();
        this.filtersForm.controls['fechaFin'].reset();
        this.filtersForm.controls['consumo'].reset();
        this.filtersForm.controls['tipoConfeccion'].reset();
        this.filtersForm.controls['codigoSNC'].reset();
      }
    }

    public filtrar() {
        this.validDates();
        if (this.filtersForm.invalid) {
            this.showError = true;
            this.showGeneralOrCountrySncMessage();
        } else if (this.filtersForm.valid) {
            this.applyFilters();
        }
    }

    private applyFilters() {
        this.currentPage = 0;
        this._etiquetadoContext.consumosFilters = {
            marcaId: this.filtersForm.get('marca').value ? this.filtersForm.get('marca').value.id : '',
            tipoConfeccionConsumo: this.filtersForm.get('consumo').value ? this.filtersForm.get('consumo').value.value : '',
            tipoConfeccionId: this.filtersForm.get('tipoConfeccion').value ? this.filtersForm.get('tipoConfeccion').value.value : '',
            campanyaId: this.filtersForm.get('campanya').value ? this.filtersForm.get('campanya').value.id : '',
            etiquetadorId: this.filtersForm.get('etiquetador').value ? this.filtersForm.get('etiquetador').value.id : '',
            almacenId: this.filtersForm.get('almacen').value ? this.filtersForm.get('almacen').value.id : '',
            municipioId: this.filtersForm.get('municipio').value ? this.filtersForm.get('municipio').value.id : '',
            paisDestinoId: this.filtersForm.get('paisDestino').value ? this.filtersForm.get('paisDestino').value.id : '',
            codigoSNC: this.filtersForm.get('codigoSNC').value ? this.filtersForm.get('codigoSNC').value : '',
            confeccionId: this.filtersForm.get('confeccion').value ? this.filtersForm.get('confeccion').value.id : '',
            nLicencia: this.filtersForm.get('licencia').value ? this.filtersForm.get('licencia').value : '',
            desFinca: this.filtersForm.get('desFinca').value ? this.filtersForm.get('desFinca').value : '',
            desProductor: this.filtersForm.get('desProductor').value ? this.filtersForm.get('desProductor').value : '',
            lote: this.filtersForm.get('lote').value ? this.filtersForm.get('lote').value : '',
            fechaInicioImpresion: this.filtersForm.get('fechaInicio').value ?
                this._utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaInicio').value) : '',
            fechaFinImpresion: this.filtersForm.get('fechaFin').value ?
                this._utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaFin').value) : '',
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage,
            orderItems: null
        };

        this.getConsumos();
    }

    public getConsumos() {
        if (this._etiquetadoContext.consumosFilters) {
            this._filters = this._etiquetadoContext.consumosFilters;
        } else {
            this.applyFilters();
        }
        this._spinnerService.showSpinner();
        this._etiquetadoService.getConsumos(this._filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.totalItems = resp.paginacionMeta.totalCount;
            this.consumos = resp.lista;
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
        });
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }

    public getIcon(prop: string, idColumn: number) {
        let iconClass = 'fa fa-sort';
        if (this._filters && this._filters.orderItems && this._filters.orderItems[0].orderProperty.indexOf(prop) != -1 && this.columnId === idColumn) {
            iconClass = this._filters.orderItems[0].orderByDescending === true ? 'fa fa-sort-down' : 'fa fa-sort-up';
        }
        return iconClass;
    }

    public toOrderBy(columnFilter, idColumn) {
        this.columnId = idColumn;
        if (this.consumos && this.consumos.length > 0) {
            if (this._etiquetadoContext.consumosFilters) {
                this._filters = this._etiquetadoContext.consumosFilters;
                if (!this.orderBy || this.orderBy.includes('DESC')) {
                    this.orderBy = 'ASC' + idColumn;
                    this._filters.orderItems = [
                        {
                            orderProperty: columnFilter,
                            orderByDescending: false
                        }
                    ];
                } else if (this.orderBy.includes('ASC')) {
                    this.orderBy = 'DESC' + idColumn;
                    this._filters.orderItems = [
                        {
                            orderProperty: columnFilter,
                            orderByDescending: true
                        }
                    ];
                }

                this._spinnerService.showSpinner();
                this._etiquetadoService.getConsumos(this._filters).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then((resp) => {
                    this.consumos = resp.lista;
                });
            }
        }
    }

    public showReimpresiones(consumo) {
        this.reimpresionesModal = true;
        this.consumoId = consumo.id;
    }

    public showIncidencias(consumo) {
        this.incidenciasModal = true;
        this.consumoId = consumo.id;
    }

    public showDetails(i: number) {
        this.dropdownInfo = this.dropdownInfo === i ? -1 : i;
        // Desplazamiento al principio del panel "Más información" para tablet (mismo tamaño máx. que en table.scss)
        if (this.dropdownInfo !== -1 && window.innerWidth <= 1199) {
            // Retardo: en caso de que haya otro detalle abierto
            setTimeout(() => {
                document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
            }, 50);
        }
    }

    public showSection(i) {
        this.dropdownSection = this.dropdownSection === i ? -1 : i;
        this.pestanaActiva[i] = this.pestanaActiva[i] > 0 ? this.pestanaActiva[i] : 1;
        if (this.dropdownSection !== -1 && window.innerWidth <= 1199) {
            setTimeout(() => {
                document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
            }, 50);
        }
    }

    public showConfeccion(i) {
        this.pestanaActiva[i] = 1;
    }

    public refresh(value) {
        this.reimpresionesModal = false;
        this.incidenciasModal = false;
    }

    public getRolePermission() {
        let disabled = false;

        if (this.role === 'Administrador') {
            disabled = false;
        } else if (this.role === 'Auditor') {
            disabled = false;
        } else if (this.role === 'Supervisor') {
            disabled = false;
        } else if (this.role === 'Etiquetador') {
            disabled = false;
        }

        return disabled;
    }

    public openDocHelp() {
      this._spinnerService.showSpinner();
      this.toCloseSpinner += 1;
      this._etiquetadoService.getDocHelp('Labeling_Transactions.pdf').toPromise().finally(() => {
          this.checkCloseSpinner();
      }).then((resp) => {
          localStorage.setItem('base64', resp.base64Archivo);
          const url = this._router.serializeUrl(this._router.createUrlTree(['viewPdf']));
          window.open(url, '_blank');
      });
    }

    private downloadPdf() {
        this._etiquetadoService.getConsumosPdf(this._filters).toPromise().finally(()=> {
            this._spinnerService.hideSpinner();
        }).then(
            (resp) => {
            const downloadLink = document.createElement('a');
            downloadLink.href = 'data:application/pdf;base64,' + resp.base64Archivo;
            downloadLink.download = resp.nombreArchivo;
            downloadLink.click();
            },
            (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.file' });
            }
        )
    }

    private downloadCsv() {
        this._etiquetadoService.getConsumosCsv(this._filters).toPromise().finally(()=> {
            this._spinnerService.hideSpinner();
        }).then(
            (resp) => {
            const downloadLink = document.createElement('a');
            downloadLink.href = 'data:text/csv;base64,' + resp.base64Archivo;
            downloadLink.download = resp.nombreArchivo;
            downloadLink.click();
            },
            (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.file' });
            }
        )
    }

    public exportPdfOrCsv(fileType: string) {
        if (this.consumos && this.consumos.length > 0) {
            if (this._etiquetadoContext.consumosFilters) {
                this._filters = this._etiquetadoContext.consumosFilters;
                this._filters.tamPagina = 0;
                this._filters.tipoArchivo = fileType === 'pdf' ? 'Pdf' : 'Csv';
            }
            this._spinnerService.showSpinner();
            fileType === 'pdf' ? this.downloadPdf() : this.downloadCsv();
        }
    }

    public trackByConsumoId(index: number, consumo: { id: number }): number {
        return consumo.id;
    }

}
